<template>
    <div class="timelimit" :class="{'error': error && limit == -1}">
        <div class="timelimit__wrapper">
            <span class="timelimit__label">Ustaw dzienny limit czasu korzystanie z aplikacji:</span>

            <div class="timelimit__items"> 
                <div class="timelimit__items-wrapper">
                    <div class="profile-new__radio timelimit__item"> 
                        <input type="radio" id="limit30" name="timelimit" value="30" v-model="limit" />
                        <label class="label" for="limit30"><span>30</span></label>
                    </div>

                    <div class="profile-new__radio timelimit__item"> 
                        <input type="radio" id="limit60" name="timelimit" value="60" v-model="limit" />
                        <label class="label" for="limit60"><span>60</span></label>
                    </div>

                    <div class="profile-new__radio timelimit__item"> 
                        <input type="radio" id="limit90" name="timelimit" value="90" v-model="limit" />
                        <label class="label" for="limit90"><span>90</span></label>
                    </div>
                </div>

                <div class="profile-new__radio timelimit__item nolimit"> 
                    <input type="radio" id="nolimit" name="timelimit" value="0" v-model="limit" />
                    <label class="label" for="nolimit"><span>Dzień bez limitu</span></label>
                </div>  
            </div>      
        </div>

        <p class="timelimit__label timelimit__label--info">
            <IconI class="timelimit__icon"></IconI>
            <span>Psycholodzy rekomendują nie więcej niż 60 min dziennie dla dziecki w wieku 3-5 lat</span>
        </p>
    </div>
</template>

<script>
import IconI from "../elements/icons/IconI.vue";

export default {
    name: "ProfileNewTimelimit",
    components: {
        IconI,
    },
    props: {
        error: {
            type: Boolean
        },
        data: {
            type: Number
        }
    },
    data() {
        return {
            limit: -1
        };
    },
    watch: {
        limit(value) {
            this.$emit('selectTimeLimit', parseInt(value));
        }
    },
    mounted() {
        this.limit = this.data;
    }
};
</script>